import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { dynamicElementsCircleTextKey } from '@epicuro-next/constants/dynamic-elements';
import { DynamicElementsTooltipDirective } from '@epicuro-next/dynamic-elements/dynamic-tooltip';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';

@DynamicComponentRegister(dynamicElementsCircleTextKey, true)
@Component({
  selector: 'epc-dynamic-elements-circle-text',
  templateUrl: './circle-text.component.html',
  styleUrls: ['./circle-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  hostDirectives: [
    {
      directive: DynamicElementsTooltipDirective,
      // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
      inputs: ['tooltip', 'tooltipPlacement', 'tooltipStyling'],
    },
  ],
})
export class DynamicElementsCircleTextComponent {
  @Input()
  public text = '';
}

DontTreeShake(DynamicElementsCircleTextComponent);
